/**
 * Import Actions Component
 *
 * Cancel and Import buttons for recipe import flow.
 */

import { router } from '@inertiajs/react';

interface ImportActionsProps {
  onImport: () => void;
  isImporting: boolean;
  isDisabled: boolean;
}

/**
 * Spinner icon for loading state
 */
function SpinnerIcon() {
  return (
    <svg
      className="animate-spin w-4 h-4"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export function ImportActions({
  onImport,
  isImporting,
  isDisabled,
}: ImportActionsProps) {
  const handleCancel = () => {
    router.visit('/food/recipes');
  };

  return (
    <div className="flex justify-end gap-3 pt-6 border-t border-gray-200">
      <button
        type="button"
        onClick={handleCancel}
        disabled={isImporting}
        className="px-5 py-2.5 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onImport}
        disabled={isDisabled || isImporting}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 border border-transparent rounded-lg text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {isImporting ? (
          <>
            <SpinnerIcon />
            Importing...
          </>
        ) : (
          'Import Recipe'
        )}
      </button>
    </div>
  );
}
